import { render, staticRenderFns } from "./ValidationExample.vue?vue&type=template&id=320eb57a&"
import script from "./ValidationExample.vue?vue&type=script&lang=js&"
export * from "./ValidationExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports